"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcPopOverLocation = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_pop_over_constants_1 = require("./bc-pop-over-constants");
var bc_pop_over_models_1 = require("./bc-pop-over-models");
var BcPopOverLocation = (function () {
    function BcPopOverLocation() {
    }
    BcPopOverLocation.prototype.getFullBoundingClientRect = function (element) {
        var bounding = element.getBoundingClientRect();
        return {
            x: bounding.x + window.scrollX,
            y: bounding.y + window.scrollY,
            bottom: bounding.bottom + window.scrollY,
            right: bounding.right + window.scrollX,
            width: bounding.width,
            height: bounding.height,
        };
    };
    BcPopOverLocation.prototype.positions = function (target, popOver) {
        return {
            target: this.getFullBoundingClientRect(target),
            popOver: this.getFullBoundingClientRect(popOver)
        };
    };
    BcPopOverLocation.prototype.getPositionPopOver = function (target, popOver, position) {
        var _a;
        var positions = this.positions(target, popOver);
        var options = (_a = {},
            _a[bc_pop_over_models_1.Directions.left] = this.positionLeft.bind(this),
            _a[bc_pop_over_models_1.Directions.right] = this.positionRight.bind(this),
            _a[bc_pop_over_models_1.Directions.top] = this.positionTop.bind(this),
            _a[bc_pop_over_models_1.Directions.bottom] = this.positionBottom.bind(this),
            _a[bc_pop_over_models_1.Directions.topLeft] = this.positionTopLeft.bind(this),
            _a[bc_pop_over_models_1.Directions.topRight] = this.positionTopRight.bind(this),
            _a[bc_pop_over_models_1.Directions.bottomRight] = this.positionBottomRight.bind(this),
            _a[bc_pop_over_models_1.Directions.bottomLeft] = this.positionBottomLeft.bind(this),
            _a[bc_pop_over_models_1.Directions.rightTop] = this.positionRightTop.bind(this),
            _a[bc_pop_over_models_1.Directions.rightBottom] = this.positionRightBottom.bind(this),
            _a[bc_pop_over_models_1.Directions.leftTop] = this.positionLeftTop.bind(this),
            _a[bc_pop_over_models_1.Directions.leftBottom] = this.positionLeftBottom.bind(this),
            _a);
        if (position in options) {
            var respuesta = options[position](positions);
            return respuesta;
        }
        else {
            return false;
        }
    };
    BcPopOverLocation.prototype.positionRight = function (positions) {
        var referenceTarget = positions.target.bottom - (positions.target.height / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2);
        var middleHeigthPopOver = positions.popOver.height / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2;
        return {
            x: positions.target.right,
            y: referenceTarget - middleHeigthPopOver
        };
    };
    BcPopOverLocation.prototype.positionLeft = function (positions) {
        var popOverX = positions.target.right - positions.target.width - positions.popOver.width;
        var referenceTarget = positions.target.bottom - (positions.target.height / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2);
        var middleHeigthPopOver = positions.popOver.height / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2;
        return {
            x: popOverX,
            y: referenceTarget - middleHeigthPopOver
        };
    };
    BcPopOverLocation.prototype.positionTop = function (positions) {
        var referenceTargetX = positions.target.right - (positions.target.width / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2);
        var middleWidhPopOver = positions.popOver.width / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2;
        return {
            x: referenceTargetX - middleWidhPopOver,
            y: positions.target.y - positions.popOver.height
        };
    };
    BcPopOverLocation.prototype.positionBottom = function (positions) {
        var referenceTargetX = positions.target.right - (positions.target.width / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2);
        var middleWidhPopOver = positions.popOver.width / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2;
        return {
            x: referenceTargetX - middleWidhPopOver,
            y: positions.target.bottom
        };
    };
    BcPopOverLocation.prototype.positionTopRight = function (positions) {
        var referenceTargetX = positions.target.right - (positions.target.width / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2);
        var fractionWidhPopOver = positions.popOver.width / bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N12;
        return {
            x: referenceTargetX - fractionWidhPopOver,
            y: positions.target.y - positions.popOver.height
        };
    };
    BcPopOverLocation.prototype.positionTopLeft = function (positions) {
        var referenceTargetX = positions.target.right - (positions.target.width / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2);
        var fractionWidhPopOver = (positions.popOver.width / bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N12) * bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N11;
        return {
            x: referenceTargetX - fractionWidhPopOver,
            y: positions.target.y - positions.popOver.height
        };
    };
    BcPopOverLocation.prototype.positionBottomRight = function (positions) {
        var referenceTargetX = positions.target.right - (positions.target.width / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2);
        var fractionWidhPopOver = positions.popOver.width / bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N12;
        return {
            x: referenceTargetX - fractionWidhPopOver,
            y: positions.target.bottom
        };
    };
    BcPopOverLocation.prototype.positionBottomLeft = function (positions) {
        var referenceTargetX = positions.target.right - (positions.target.width / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2);
        var fractionWidhPopOver = (positions.popOver.width / bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N12) * bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N11;
        return {
            x: referenceTargetX - fractionWidhPopOver,
            y: positions.target.bottom
        };
    };
    BcPopOverLocation.prototype.positionRightTop = function (positions) {
        var referenceTarget = positions.target.bottom - (positions.target.height / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2);
        var fractionHeigthPopOver = (positions.popOver.height / bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N12) * bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N11;
        return {
            x: positions.target.right,
            y: referenceTarget - fractionHeigthPopOver
        };
    };
    BcPopOverLocation.prototype.positionRightBottom = function (positions) {
        var referenceTarget = positions.target.bottom - (positions.target.height / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2);
        var fractionHeigthPopOver = positions.popOver.height / bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N12;
        return {
            x: positions.target.right,
            y: referenceTarget - fractionHeigthPopOver
        };
    };
    BcPopOverLocation.prototype.positionLeftTop = function (positions) {
        var popOverX = positions.target.right - positions.target.width - positions.popOver.width;
        var referenceTarget = positions.target.bottom - (positions.target.height / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2);
        var fractionHeigthPopOver = (positions.popOver.height / bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N12) * bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N11;
        return {
            x: popOverX,
            y: referenceTarget - fractionHeigthPopOver
        };
    };
    BcPopOverLocation.prototype.positionLeftBottom = function (positions) {
        var popOverX = positions.target.right - positions.target.width - positions.popOver.width;
        var referenceTarget = positions.target.bottom - (positions.target.height / common_constants_1.COMMON_CONSTANTS_NUMBERS.N2);
        var fractionHeigthPopOver = positions.popOver.height / bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_N12;
        return {
            x: popOverX,
            y: referenceTarget - fractionHeigthPopOver
        };
    };
    return BcPopOverLocation;
}());
exports.BcPopOverLocation = BcPopOverLocation;
